"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
var use_context_selector_1 = require("use-context-selector");
var houston_styles_1 = require("@eduzz/houston-styles");
var error_1 = tslib_1.__importDefault(require("../../utils/error"));
var context_1 = tslib_1.__importDefault(require("../context"));
var context_2 = tslib_1.__importDefault(require("../Header/context"));
var SortLabel_1 = tslib_1.__importDefault(require("./SortLabel"));
var TableColumn = function (_a) {
    var sortableField = _a.sortableField, children = _a.children, className = _a.className, rest = tslib_1.__rest(_a, ["sortableField", "children", "className"]);
    var onSort = (0, use_context_selector_1.useContextSelector)(context_2.default, function (context) { return context.onSort; });
    var sortField = (0, use_context_selector_1.useContextSelector)(context_2.default, function (context) { return context.sortField; });
    var sortDirection = (0, use_context_selector_1.useContextSelector)(context_2.default, function (context) { return context.sortDirection; });
    var loading = (0, use_context_selector_1.useContextSelector)(context_1.default, function (context) { return context.loading; });
    var isSorted = sortField === sortableField;
    var handleSort = React.useCallback(function () {
        if (!onSort || !sortableField) {
            (0, error_1.default)('TableColumn', 'add the onSort and sortableField prop to the TableHeader to filter the fields');
            return;
        }
        onSort(sortableField, !isSorted || sortDirection === 'desc' ? 'asc' : 'desc');
    }, [onSort, sortableField, isSorted, sortDirection]);
    return ((0, jsx_runtime_1.jsx)("th", tslib_1.__assign({ className: (0, houston_styles_1.cx)(className, 'hts-table-column', { 'hts-table-column-disabled': loading }) }, rest, { children: (0, jsx_runtime_1.jsx)(SortLabel_1.default, tslib_1.__assign({ sortable: !!sortableField, active: isSorted, disabled: loading, direction: isSorted ? sortDirection : 'asc', onClick: handleSort }, { children: children })) })));
};
/**
 * @deprecated Use Table from Antd
 * https://ant.design/components/table/
 */
exports.default = React.memo(TableColumn);
